var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Router"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Router",
    clipPath: "url(#clip-Router)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "router-2",
    "data-name": "router",
    transform: "translate(9.998 15.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(44.14 201.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M414.9,326.615h52.966V211.742H414.9Z",
    transform: "translate(-72.067 -211.742)",
    fill: "#8b8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M44.14,326.615H97.105V211.742H44.14Z",
    transform: "translate(-44.14 -211.742)",
    fill: "#8b8c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M16.694,326.621C7.48,326.621,0,334.531,0,344.276V467.862c0,9.746,7.479,17.655,16.692,17.655H467.383c9.214,0,16.692-7.91,16.692-17.655V344.276c0-9.746-7.479-17.655-16.692-17.655Z",
    transform: "translate(-0.002 -19.349)",
    fill: "#c6c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M450.209,0l8.827,211.747h-35.31L432.553,0Z",
    transform: "translate(-27.929)",
    fill: "#c6c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M467.864,255.883H414.9a8.828,8.828,0,1,1,0-17.656h52.966a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-27.929 -9.852)",
    fill: "#c6c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M467.864,291.194H414.9a8.828,8.828,0,1,1,0-17.656h52.966a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-27.929 -11.313)",
    fill: "#c6c9cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(44.14 466.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M44.14,512h70.62V485.521H44.14Z",
    transform: "translate(-44.14 -485.521)",
    fill: "#8b8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M397.243,512h70.621V485.521H397.243Z",
    transform: "translate(-72.067 -485.521)",
    fill: "#8b8c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M79.45,0l8.828,211.747H52.967L61.795,0Z",
    transform: "translate(-35.312)",
    fill: "#c6c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M97.105,255.883H44.14a8.828,8.828,0,0,1,0-17.656H97.106a8.828,8.828,0,1,1,0,17.656",
    transform: "translate(-35.312)",
    fill: "#c6c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M97.105,291.194H44.14a8.828,8.828,0,0,1,0-17.656H97.106a8.828,8.828,0,1,1,0,17.656",
    transform: "translate(-35.312)",
    fill: "#c6c9cb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M300.14,406.069A44.138,44.138,0,1,1,256,361.931a44.137,44.137,0,0,1,44.138,44.138",
    transform: "translate(-13.964 -19.349)",
    fill: "#c03a2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(35.312 381.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M61.795,414.9H44.14a8.828,8.828,0,0,1,0-17.656H61.795a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-35.312 -397.241)",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M114.76,414.9H97.105a8.828,8.828,0,0,1,0-17.656H114.76a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-35.312 -397.241)",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M167.726,414.9H150.071a8.828,8.828,0,0,1,0-17.656h17.655a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-42.597 -397.241)",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M361.933,414.9H344.278a8.828,8.828,0,0,1,0-17.656h17.655a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-55.954 -397.241)",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M414.9,414.9H397.243a8.828,8.828,0,0,1,0-17.656H414.9a8.828,8.828,0,1,1,0,17.656",
    transform: "translate(-63.239 -397.241)",
    fill: "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M467.864,414.9H450.209a8.828,8.828,0,0,1,0-17.656h17.655a8.828,8.828,0,0,1,0,17.656",
    transform: "translate(-63.239 -397.241)",
    fill: "#24ae5f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/Router.3741c14d668abfdb4a43e8b0b00db0c1.svg";
export { ForwardRef as ReactComponent };